export default __webpack_public_path__ + "static/media/1. What is UOA-small.b18c1d76.jpg";